<template>
  <div class="collections pt-5 pa-2">
    <!-- img cards -->
    <v-flex xs12>
      <v-card>
        <v-container grid-list-sm fluid>
          <v-layout align-center justify-space-between row>
            <h1 class="mb-4">Collections ({{collections.length}})</h1>

            <v-btn
              class="red white--text mb-3"
              @click="removeAll"
              v-if="collections.length"
            >Remove All</v-btn>
          </v-layout>
          <v-layout row wrap>
            <div
              v-for="(n, index) in collections"
              :key="index"
              class="flex lg3 md4 sm6 xs12"
              d-flex
            >
              <v-hover>
                <v-card class="pa-1 coll-img" slot-scope="{hover}">
                  <v-layout row wrap class="img-card">
                    <v-img :src="n.url" aspect-ratio="1.5" class="grey lighten-2">
                      <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </v-img>
                  </v-layout>

                  <div class="coll-actions" v-if="hover">
                    <v-btn
                      class="xbtn red darken-4 white--text"
                      fab
                      small
                      @click="removeImg(n, index)"
                    >
                      <v-icon class="mt-3 mx-auto">close</v-icon>
                    </v-btn>
                    <div class="text-lg-center">
                      <a
                        :href="downloadImg(n.url)"
                        class="v-btn orange white--text downloadBtn"
                      >Download Image</a>
                    </div>
                  </div>
                </v-card>
              </v-hover>
            </div>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  name: "collections-page",
  data() {
    return {
      hideImgAni: {
        display: "none !important",
        animation: "hide 1s linear"
      }
    };
  },
  computed: {
    ...mapGetters(["collections"])
  },
  methods: {
    removeImg(n, i) {
      this.$store.dispatch("deleteCollections", n);
    },
    removeAll() {
      this.$store.commit("remove_all");
    },

    downloadImg(url) {
      return `${url}?attachment&modal`;
    }
  }
};
</script>

<style>
.call-img {
  position: relative;
  box-sizing: border-box;
}
.coll-actions {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(88, 228, 228, 0.5);
  width: 100%;
  height: 100%;
}
.xbtn {
  position: absolute !important;
  top: 5px;
  right: 5px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>